import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link, useLocation} from 'react-router-dom';
import auth from '../auth';
import CircleProgressIndicator from './circle_progress_indicator';

export default ({children}) => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const autoLogin = location.pathname.startsWith('/student/finalize');

  useEffect(() => {
     new Promise(resolve => {
       if (!auth.refreshToken) {
         history.push('/login');
         resolve();
       } else {
         if (auth.token || autoLogin) {
          auth.refresh()
           .then(resolve)
           .catch(() => {
             history.push('/login');
             resolve();
           });
         } else {
           history.push('/login');
           resolve();
         }
       }
     })
       .then(() => setOpen(true));
   }, []);

   return open ? children : (
     <span css={css`position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto; width: 96px; height: 96px`}>
       <CircleProgressIndicator size={48}/>
       <p css={css`color: #CCC`}>認証中</p>
     </span>
   );
}
